import { MerchantAdminApi } from "../Api";

export enum ImageType {
  VENUE_PRODUCT_MAIN = 'venue/product/main',
  VENUE_BENEFIT_MAIN = 'venue/benefit/main',
  VENUE_EVENT_MAIN = 'venue/event/main',
  VENUE_LOGO = 'venue/logo',
  VENUE_MAIN = 'venue/main',
  MESSAGE_PUSH_BODY = 'MESSAGE_PUSH_BODY',
  MESSAGE_EMAIL_BODY = 'message/email/body'
}

export const uploadImage = async (
  api: MerchantAdminApi | undefined,
  imageFile: File,
  imageType: ImageType,
  context: string = 'image'
): Promise<string> => {
  try {
    if (!api) {
      throw new Error('API client is not initialized');
    }

    if (!imageFile) {
      throw new Error('No image file provided');
    }

    const imageURL = await api.uploadImage(imageType, imageFile);
    
    if (!imageURL) {
      throw new Error('Failed to upload image: No URL returned from server');
    }

    return imageURL;
  } catch (error) {
    console.error(`Error uploading ${context} image:`, error);
    if (error instanceof Error) {
      throw new Error(`Failed to upload image: ${error.message}`);
    }
    throw new Error('Failed to upload image: Unknown error occurred');
  }
}; 